"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ImageUpload from "../services/imageUpload.service";
import errorService from "../services/error.service";
import messageService from "../messages/messageService";
import userService from "../users/userService";
import ChatLoader, { Chat } from "../messages/chat";
import ChunkLoader, { Chunk } from "../messages/chatChunk";
var State = require("asset/state");
var Bluebird = require("bluebird");
var controllerModule = require("controllers/controllerModule");
var sendToUserTopic = function (users) {
    if (users.length > 1) {
        return Bluebird.resolve();
    }
    return messageService.getUserChat(users[0]);
};
var sendNewChat = function (receiver, text, attachments) {
    return Bluebird.coroutine(function () {
        var chatID, chunkData, receiverObjects, chunk, chat;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sendToUserTopic(receiver)];
                case 1:
                    chatID = _a.sent();
                    if (chatID) {
                        return [2 /*return*/, ChatLoader.get(chatID)
                                .then(function (chat) {
                                chat.sendMessage(text, attachments);
                                return null;
                            }).thenReturn(chatID)];
                    }
                    receiver.sort();
                    return [4 /*yield*/, Chunk.createRawData(receiver, { content: {} })];
                case 2:
                    chunkData = _a.sent();
                    return [4 /*yield*/, userService.getMultiple(receiver)];
                case 3:
                    receiverObjects = _a.sent();
                    chunk = new Chunk({
                        content: {},
                        server: {
                            id: -1,
                            chatID: -1,
                            createTime: Date.now()
                        },
                        meta: chunkData.chunk.meta,
                        receiverObjects: receiverObjects.map(function (u) { return u.data; })
                    }, chunkData);
                    chat = new Chat({ id: -1, latestMessage: null, latestChunk: chunk, unreadMessageIDs: [] }, true);
                    ChunkLoader.addLoaded(-1, chunk);
                    ChatLoader.addLoaded(-1, chat);
                    return [4 /*yield*/, chat.sendMessage(text, attachments)];
                case 4:
                    _a.sent();
                    return [2 /*return*/, chat.getID()];
            }
        });
    })();
};
var messagesController = function ($scope, $state, $stateParams) {
    $scope.canSend = false;
    $scope.topicLoaded = false;
    var sendMessageState = new State.default();
    $scope.sendMessageState = sendMessageState.data;
    $scope.create = {
        text: "",
        setUsers: function (users) {
            $scope.create.users = users;
        },
        users: [],
        images: [],
        removeImage: function (index) {
            $scope.create.images.splice(index, 1);
        },
        addImages: ImageUpload.fileCallback(function (files) {
            $scope.$applyAsync(function () {
                $scope.create.images = $scope.create.images.concat(files.map(function (file) { return new ImageUpload(file); }));
            });
        }),
        send: function (receiver, text, images) {
            images = images || [];
            sendMessageState.pending();
            if (text === "" && images.length === 0) {
                sendMessageState.failed();
                return;
            }
            var newTopicPromise = sendNewChat(receiver, text, { images: images, files: [], voicemails: [] }).then(function (id) {
                $scope.create.text = "";
                $scope.create.selectedElements = [];
                $scope.goToShow(id);
                $scope.$broadcast("resetSearch");
            });
            errorService.failOnErrorPromise(sendMessageState, newTopicPromise);
        }
    };
    function getUser(userid) {
        return userService.get(userid).then(function (user) {
            return user.loadBasicData().then(function () {
                return [user.data];
            });
        });
    }
    function loadInitialUser() {
        if (!$stateParams.userid) {
            return Bluebird.resolve([]);
        }
        return messageService.getUserChat($stateParams.userid).then(function (chatID) {
            if (chatID) {
                $scope.goToShow(chatID);
                return [];
            }
            else {
                return getUser($stateParams.userid);
            }
        });
    }
    $scope.goToShow = function (topicid) {
        $state.go("app.messages.show", {
            topicid: topicid
        });
    };
    var loadInitialUserPromise = loadInitialUser();
    $scope.getInitialUser = function () {
        return loadInitialUserPromise;
    };
};
messagesController.$inject = ["$scope", "$state", "$stateParams"];
controllerModule.controller("ssn.messagesCreateController", messagesController);



//////////////////
// WEBPACK FOOTER
// ./js/messages/messagesCreateController.ts
// module id = yR5P
// module chunks = 1